module.exports = __webpack_public_path__ + "img/cpzs1.f35b8aac.png";